import React, { useState } from "react";
import Column from "@amzn/meridian/column";
import LandingHeader from "src/components/pages/landing/header";
import LandingHome from "src/components/pages/landing/home";
import LandingFooter, { NavTab } from "src/components/pages/landing/footer";
import HistoryView from "src/components/pages/landing/historyView";
import "./landing.scss";

const LandingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<NavTab>(NavTab.HOME);

  return (
    <div className="app-gradient-bg pwa-scrollable">
      <Column className="home-content" spacingInset="none none 600">
        <LandingHeader />
        {activeTab === NavTab.HOME && <LandingHome />}
        {activeTab === NavTab.HISTORY && <HistoryView />}
      </Column>
      <LandingFooter active={activeTab} onTabChange={setActiveTab} />
    </div>
  );
};

export default LandingPage;
